/*-----------------------------------------------------------------------------
|> Common utility functions
|------------------------------------------------------------------------------
|
| Provide common functionalities shared by app's modules.
|
-----------------------------------------------------------------------------*/

import { isNumber, isObject, isString } from 'lodash';
// import { isNumber, isObject, isString } from 'lodash-es';


/**
 * Set query parameters on provided URL
 *
 * @param {string} url URL which query string is to be set
 * @param {object} queries Object containing the query parameters as {key:(string)value} pair
 *
 * @return {string} A new URI with the query string appended
 */
export function makeUrl(url, queries) {
    if (!isString(url) || !isObject(queries)){
        throw 'Expected parameter `url` to be of type string and `queries` to be an object';
    }

    let queryString = '';

    /* build the query string */
    for (const query in queries) {
        if (Object.prototype.hasOwnProperty.call(queries, query)) {
            queryString += (isString(queries[query]) || isNumber(queries[query]))
                ? `&${ query }=${ queries[query] }`
                : ''
            ;
        }
    }

    /* return original URL if query string is empty */
    if (0 === queryString.length) return url;

    /* If URL has existing query, return new URI with appended parameters */
    if (-1 !== url.indexOf('?')) return url+queryString;

    /* Remove first "&" in query string and return new URI  */
    return `${ url }?${ queryString.slice(1) }`;
}
